import { render, staticRenderFns } from "./CounselorDocumentTable.vue?vue&type=template&id=7f4d43c8&scoped=true&"
import script from "./CounselorDocumentTable.vue?vue&type=script&lang=js&"
export * from "./CounselorDocumentTable.vue?vue&type=script&lang=js&"
import style0 from "./CounselorDocumentTable.vue?vue&type=style&index=0&id=7f4d43c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4d43c8",
  null
  
)

export default component.exports